import React, { useState } from "react";
import { Modal, Tooltip } from "antd";
import AiBot from "./AiBot";

const InstructionsButton: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="AI Bot" placement="left">
        <button
          type="button"
          aria-label="AI Bot"
          onClick={() => setOpen(true)}
          className="
            fixed bottom-6 right-6 z-50
            h-[60px] w-[60px] rounded-full
            border border-sky-200/55
            bg-[radial-gradient(120%_120%_at_35%_30%,rgba(96,165,250,0.28)_0%,rgba(59,130,246,0.22)_35%,rgba(30,64,175,0.18)_70%,rgba(15,23,42,0.22)_100%)]
            shadow-[0_18px_35px_rgba(0,0,0,0.45),0_0_0_6px_rgba(59,130,246,0.18)]
            backdrop-blur-[10px]
            flex items-center justify-center
            text-[18px] font-extrabold tracking-[0.08em] text-white/95 uppercase
            hover:shadow-[0_22px_45px_rgba(0,0,0,0.55),0_0_0_8px_rgba(59,130,246,0.22)]
            active:scale-95 transition
          "
        >
          AI
        </button>
      </Tooltip>

      <Modal open={open} onCancel={() => setOpen(false)} footer={null} title="AI Bot" destroyOnClose>
        <AiBot />
      </Modal>
    </>
  );
};

export default InstructionsButton;